/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const CHIP_COLOR = "#3766E8";

export const TagRoot = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "4px 6px 4px 12px",
  borderRadius: 10,
  border: "1px solid #CFE0FF",
  backgroundColor: "#F4F8FF",
  whiteSpace: "nowrap",
  flexShrink: 0,
}));

export const TagTextWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const TagName = styled(Typography)(() => ({
  color: CHIP_COLOR,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.3,
}));

export const TagPairLabel = styled(Typography)(() => ({
  color: CHIP_COLOR,
  fontSize: 11,
  fontWeight: 400,
  lineHeight: 1.3,
}));

export const TagActionsWrapper = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 0,
}));

export const TagIconButton = styled(IconButton)(() => ({
  padding: 2,
  color: CHIP_COLOR,
  "&:hover": {
    backgroundColor: "rgba(55, 102, 232, 0.08)",
  },
}));
